import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonCommon from '../../common/button/ButtonCommon';
import { useAlert } from '../../common/alert/AlertContextProvider';
import { deletePopup } from '../../../api/function/popup';
import { PopupOpenType } from '../../../api/types/PopupOpenType';

interface Props {
  id: number;
  // 저장된 게시 여부. 화면에서 스위치만 바꾼 상태로는 지울 수 없게 저장값을 본다
  savedOpenType: PopupOpenType;
}

const PopupDetailDeleteButton = ({ id, savedOpenType }: Props) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const alert = useAlert();
  const navigate = useNavigate();
  const isHidden = savedOpenType === PopupOpenType.HIDDEN;

  const handleClickDelete = async () => {
    if (!isHidden) {
      alert('게시 중인 팝업은 삭제할 수 없습니다. 비공개로 저장한 뒤 삭제해 주세요.');
      return;
    }
    if (!confirm('팝업을 삭제할까요? 삭제하면 되돌릴 수 없습니다.')) return;

    try {
      setIsDeleting(true);
      await deletePopup(id);
      navigate('/popup/list');
    } catch (e: any) {
      alert(e.cause ?? '팝업을 삭제하지 못했습니다.');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <ButtonCommon
      size={'large'}
      type={'red-line'}
      onClick={handleClickDelete}
      loading={isDeleting}
      title={isHidden ? undefined : '비공개로 저장한 팝업만 삭제할 수 있습니다.'}
    >
      삭제
    </ButtonCommon>
  );
};

export default PopupDetailDeleteButton;
